export default __webpack_public_path__ + "static/media/faci07.217673fa.jpg";